import { Component, OnInit } from '@angular/core';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';

@Component({
    selector: 'app-depot-stock-locations',
    templateUrl: './depot-stock-locations.component.html',
    styleUrls: ['./depot-stock-locations.component.scss'],
    standalone: false
})
export class DepotStockLocationsComponent implements OnInit {

  buttons: GridButton[] = [
    {label: 'Edit', link: '/workshop/depot-stock-locations/edit/:id', type: 'btn-warning'} as GridButton,
  ]

  columns: GridColumn[] = [
    {active: true, label: '#', field: 'id'} as GridColumn,
    {active: true, label: 'Depot', field: 'account.name'} as GridColumn,
    {active: true, label: 'Warehouse', field: 'warehouseLocation.warehouse.name'} as GridColumn,
    {active: true, label: 'Aisle', field: 'warehouseLocation.aisle'} as GridColumn,
    {active: true, label: 'Shelf', field: 'warehouseLocation.shelf'} as GridColumn,
  ];

  constructor() { }

  ngOnInit(): void {
  }
}
